// @core/api/endpoints/team/delete_team_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/team';

/**
 * Delete team role
 * Deletes a custom team role. Members with this role must be reassigned to another role before deletion.
 */
export async function DeleteTeamRole(
  team_id: string,
  role_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/roles/:role_id`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':role_id', encodeURIComponent(role_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
